<template>
      <div >
        <el-row v-for="(v, i) in list" :key="i + new Date().getTime()" style="border-bottom: 1px #d9d9d9 solid;" >
          <el-col :span="6"  >

            <img :src="myUtil.generateProductImg(v)" style="width: 90%; max-width: 120px;" onerror="this.error = null">
          </el-col>
          <el-col :span="18"  >
            <el-row style="padding: 8px;">
              <el-col :span="24" style="text-align: left">
                <span tkey="產品id">id : {{v.productid}}</span>
              </el-col>

              <el-col :span="24"  style="text-align: left">
                <span tkey="產品名稱">{{i18n.tkey("lang_product_name")}} : {{v.productname}}</span>
              </el-col>
              <el-col :span="24"  style="text-align: left">
                <span tkey="公司名稱">{{i18n.tkey("lang_company_name")}} : {{v.companyname}}</span>
              </el-col>

              <el-col :span="24"  style="text-align: left">
                <span tkey="產品單位">{{i18n.tkey("lang_product_unit")}} : {{v.unit}}</span>
              </el-col>
              <el-col :span="24"  style="text-align: left">
                <span tkey="點擊數量">{{i18n.tkey("lang_click")}}{{i18n.tkey("lang_qty")}} : {{v.raddinfo3}}</span>
              </el-col>
              <el-col :span="18" style="text-align: left">
                <span tkey="產品價格">{{i18n.tkey("lang_price_text")}} : {{v.raddinfo2}}</span>
              </el-col>
              <el-col :span="6"  style="text-align: right">

                &nbsp; <el-text
                  type="primary"
                  @click="clickEdit(v)"
                  tkey="編輯"
              >
                {{i18n.tkey("lang_modify")}}
              </el-text>
                <el-text
                    style="margin-left: 8px;"
                    type="danger"
                    @click="clickDelBtn(v.rupdatedid)"
                >
                  {{i18n.tkey("lang_delete")}}
                </el-text>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-empty :description="i18n.tkey('lang_temporary_no_data')" v-show="list.length === 0">

        </el-empty>
      </div>
</template>

<script setup>

import {inject, ref} from "vue";
import myUtil from "@/util/util";
import record15Api from "@/request/record15Api";
import record16Api from "@/request/record16Api";

const props = defineProps(["list"])
const emits = defineEmits(["save-success", "del-success", "clickEdit"])

const i18n = inject("i18n")
const loading = ref(false)

function clickDelBtn(id){
    myUtil.confirmWarning(i18n.tkey("lang_delete_confirm"), () => {
        delRecord16(id)
    })
}

function delRecord16(id){
    loading.value = true

    const request = record16Api.delAdditionalrecord16
    const params = request.getParams()

    params.id = id

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_delete_success"))
            emits("del-success")
        }else{
            myUtil.alertError(res.msg)
        }

    })

}

// function approvedRecord(obj){
//     loading.value = true
//
//     const request = record15Api.updateRecordStats
//     const params = request.getParams()
//
//     params.id = obj.id
//     params.recordno = -1
//
//     request.send(params, (res) => {
//         loading.value = false
//
//         if (res.code == 200){
//             myUtil.alertSuccess(i18n.tkey("lang_save_success"))
//             emits("save-success")
//         }else{
//             myUtil.alertError(res.msg)
//         }
//     })
//
// }

// function clickApproved(obj){
//     myUtil.confirmWarning(i18n.tkey("lang_approved_confirm"), () => {
//         approvedRecord(obj)
//     })
// }

function clickEdit(obj){
    emits("clickEdit", obj)
}

</script>

<style scoped>

</style>